import React, { useState } from 'react';
import { Button } from '@attentive-platform/stem-ui';

import { inactiveItemTypeLabel } from './inactiveItems';
import { FormScreenStyles as S } from './styles';

const InactiveItemsBanner = ({ items, onViewTrade }) => {
  const [open, setOpen] = useState(true);
  if (!items?.length) return null;

  const countLabel = `${items.length} item${items.length === 1 ? '' : 's'}`;

  return (
    <S.InfoPanel>
      <S.InfoInner>
        <S.InfoHead>
          <S.InfoTag>Info</S.InfoTag>
          <S.InfoTitle>Some picks need re-picking</S.InfoTitle>
          <S.InfoToggle type='button' aria-expanded={open} onClick={() => setOpen(v => !v)}>
            {open ? 'Hide items' : `Show ${countLabel}`}
          </S.InfoToggle>
        </S.InfoHead>
        {open ? (
          <S.InfoList>
            {items.map(item => (
              <S.InfoRow key={item.id}>
                <S.InfoKind>Re-pick</S.InfoKind>
                <S.InfoCopy>
                  <S.InfoName>{item.name}</S.InfoName>
                  <S.InfoDetail>
                    {[
                      item.tradeName,
                      `${inactiveItemTypeLabel(item.type)} renamed in our catalog · Find it and tick it again`
                    ]
                      .filter(Boolean)
                      .join(' · ')}
                  </S.InfoDetail>
                </S.InfoCopy>
                {item.tradeName && onViewTrade ? (
                  <Button variant='text' color='primary' size='medium' onClick={() => onViewTrade(item)}>
                    {`Find in ${item.tradeName} trade`}
                  </Button>
                ) : null}
              </S.InfoRow>
            ))}
          </S.InfoList>
        ) : null}
      </S.InfoInner>
    </S.InfoPanel>
  );
};

export default InactiveItemsBanner;
